<template>
<div class="container">
  <div class="row">
    <div class="col-12 text-right">
      <img style="width:180px; margin:20px;" src="https://tma-bensberg.de/wp-content/uploads/2015/10/tma-logo.png"/>
    </div>
  </div>
  <div class="jumbotron">
  <h1 class="display-5">Die von Ihnen gewählte Veranstaltung ist leider online nicht mehr buchbar!</h1>
  <p class="lead">Bitte senden Sie Ihren Buchungswunsch an die unten stehende E-Mail Adresse. Wir prüfen gerne, ob wir weitere Plätze anbieten können.</p>
  <hr class="my-4">
    <a href="mailto:akademie@tma-bensberg.de" class="btn btn-primary btn-lg" role="button">akademie@tma-bensberg.de</a>
</div>
</div>
</template>

<script>
    export default {
        name: "booked-up"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/booked-up.vue